import api from '../core/api';

export async function getSmsGateways() {
  const res = await api.get('/sms/gateways');
  return res.data.data;
}

export async function updateSmsGateway(type: string, data: Record<string, unknown>) {
  const res = await api.put(`/sms/gateways/${type}`, data);
  return res.data.data;
}

export async function testSms(phone: string, message?: string) {
  const res = await api.post('/sms/test', { phone, message: message || 'Test SMS from Super SaaS' });
  return res.data;
}
